import { render, staticRenderFns } from "./TaskComment.vue?vue&type=template&id=059fb03e&scoped=true&"
import script from "./TaskComment.vue?vue&type=script&lang=js&"
export * from "./TaskComment.vue?vue&type=script&lang=js&"
import style0 from "./TaskComment.vue?vue&type=style&index=0&id=059fb03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fb03e",
  null
  
)

export default component.exports